const SortDirections = {
  desc: 'desc',
  asc: 'asc'
}

export default SortDirections
